import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { useAuthStore } from '../../store/authStore';
import type { Aluno } from '../../types/models';

/**
 * Alunos ativos da turma para o fluxo de chamada (escopo validado no backend).
 * GET /escolas/:escolaId/chamadas/turma/:turmaId/alunos
 */
export function useAlunosTurmaChamada(turmaId?: string) {
  const escolaId = useAuthStore((s) => s.escolaId);

  const query = useQuery({
    queryKey: ['chamada-alunos-turma', escolaId, turmaId],
    queryFn: async () => {
      const { data } = await api.get<{ turma: { id: string; nome: string }; alunos: Aluno[] }>(
        `/escolas/${escolaId}/chamadas/turma/${turmaId}/alunos`,
      );
      return (data?.alunos ?? []) as Aluno[];
    },
    enabled: !!escolaId && !!turmaId,
    staleTime: 60_000,
  });

  return {
    alunos: query.data ?? [],
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
